export default "__VITE_ASSET__DMyHKddL__"